import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { NzTreeIndentComponent } from "ng-zorro-antd/tree";

@Component({
  selector: "ui-tree-indent",
  exportAs: "uiTreeIndent",
  templateUrl: "tree-indent.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiTreeIndentComponent extends NzTreeIndentComponent {
  @Input("uiTreeLevel") public nzTreeLevel = 0;
  @Input("uiIsStart") public nzIsStart: boolean[] = [];
  @Input("uiIsEnd") public nzIsEnd: boolean[] = [];
  @Input("uiSelectMode") public nzSelectMode = false;
}
